import React, { useState, useEffect } from "react";
import {
  Button,
  IconButton,
  Stack,
  ListItemText,
  ImageList,
  ImageListItem,
  TextField,
  Typography,
  InputAdornment,
  Checkbox,
  Avatar,
  ListItem,
  Modal,
  Box,
  Card,
  useMediaQuery,
  useTheme,
  ImageListItemBar,
  Grid
} from "@mui/material";
import { Close } from "@mui/icons-material";
import defaultProjectImage from "../../assets/images/placeholder_img.jpg";
import PictureViewer from "../../common/PictureViewer.jsx";
import {
  BUY_SELL_SAVE_USER_ITEM,
  BUY_SELL_SAVE_USER_ITEM_PICTURE,
  DELETE_BUY_SELL_USER_ITEM_PICTURES
} from "../../constant/Apipath.jsx";
import { useSelector } from "react-redux";
import { English } from "../../constant/EnglishFallback.jsx";
import { Postrequestcall } from "../../request/Postrequest.jsx";
import { getFormattedAddress } from "../common/GetFormattedAddress";
import SiteListForBuySell from "./SiteListForBuySell";
import ImageIcon from "@mui/icons-material/Image";
import CloseIcon from "@mui/icons-material/Close";

const AddListing = (props) => {
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);

  // Language data
  const LanguageData = multiLanguageData?.BuySell || {};

  const {
    TEXT_EDIT_LISTING_HEADER = English.BuySell.TEXT_EDIT_LISTING_HEADER,
    TEXT_CREATE_NEW_LISTING_HEADER = English.BuySell.TEXT_CREATE_NEW_LISTING_HEADER,
    TEXT_PHOTOS_LABEL = English.BuySell.TEXT_PHOTOS_LABEL,
    TEXT_ADD_PHOTO = English.BuySell.TEXT_ADD_PHOTO,
    TEXT_SELLING_TRADING_LABEL = English.BuySell.TEXT_SELLING_TRADING_LABEL,
    TEXT_SELLING_TRADING_PLACEHOLDER = English.BuySell.TEXT_SELLING_TRADING_PLACEHOLDER,
    TEXT_PRICE_LABEL = English.BuySell.TEXT_PRICE_LABEL,
    TEXT_PRICE_PLACEHOLDER = English.BuySell.TEXT_PRICE_PLACEHOLDER,
    TEXT_FOR_TRADE_CHECKBOX = English.BuySell.TEXT_FOR_TRADE_CHECKBOX,
    TEXT_DESCRIPTION_LABEL = English.BuySell.TEXT_DESCRIPTION_LABEL,
    TEXT_DESCRIPTION_PLACEHOLDER = English.BuySell.TEXT_DESCRIPTION_PLACEHOLDER,
    TEXT_LOCATION_SITE_LABEL = English.BuySell.TEXT_LOCATION_SITE_LABEL,
    TEXT_SELECT_SITE_BTN = English.BuySell.TEXT_SELECT_SITE_BTN,
    TEXT_UPDATE_LISTING_BTN = English.BuySell.TEXT_UPDATE_LISTING_BTN,
    TEXT_CREATE_LISTING_BTN = English.BuySell.TEXT_CREATE_LISTING_BTN,
    TEXT_INVALID_IMAGE_ALERT = English.BuySell.TEXT_INVALID_IMAGE_ALERT
  } = LanguageData;
  let currentUserId = loginData?.userInformation?.UserId ?? 0;
  const [pictures, setPictures] = useState([]);
  const [title, setTitle] = useState("");
  const [price, setPrice] = useState("");
  const [description, setDescription] = useState("");
  const [forTrade, setForTrade] = useState(false);
  const [selectedSiteDetails, setSelectedSiteDetails] = useState(null);
  const [deletedImages, setDeletedImages] = useState([]);
  const [btnLoading, setBtnLoading] = useState(false);
  const [pictureViewerOpen, setPictureViewerOpen] = useState(false);
  const [showSites, setShowSites] = useState(false);
  const [pictureViewIndex, setPictureViewIndex] = useState(0);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    if (props?.editListItemDetails) {
      setTitle(props?.editListItemDetails?.title ?? "");
      setPrice(props?.editListItemDetails?.price ?? "");
      setForTrade(props?.editListItemDetails?.forTrade ?? false);
      setDescription(props?.editListItemDetails?.description ?? "");
      setPictures(props?.editListItemDetails?.pictureList ?? []);
      setSelectedSiteDetails(props?.editListItemDetails);
    }
  }, [props?.editListItemDetails]);

  const onClose = () => {
    setTitle("");
    setPictures([]);
    setTitle("");
    setPrice("");
    setDescription("");
    setForTrade(false);
    setSelectedSiteDetails(null);
    setDeletedImages([]);
    setBtnLoading(false);
    return props?.onClose();
  };

  function handleChooseFile(event) {
    const files = event.target.files;
    let allFilesValid = true;
    if (files?.length > 0) {
      for (let i = 0; i < files.length; i++) {
        if (!files[i].type.startsWith("image/")) {
          allFilesValid = false;
          break;
        }
      }
    }
    if (!allFilesValid) {
      return alert(TEXT_INVALID_IMAGE_ALERT);
    }
    let images = [];
    for (let i = 0; i < files?.length; i++) {
      images.push(files[i]);
    }
    setPictures([...pictures, ...images]);
    event.target.value = null;
  }

  const onDeletePicturePressed = (picItem, picIndex) => {
    if (picItem?.id) {
      setDeletedImages([...deletedImages, picItem]);
    }
    let updatePicturesList = pictures.filter((item, index) => index !== picIndex);
    setPictures(updatePicturesList);
  };

  const onPriceChange = (val) => {
    try {
      if (val.startsWith("0") && val?.length > 1) {
        val = val.replace(/^0+/, "0");
      }
      let numericValue = val.replace(/[^0-9.]/g, "");
      if (numericValue.includes(".")) {
        const [beforeDecimal, afterDecimal] = numericValue.split(".");
        numericValue = beforeDecimal.slice(0, 4) + "." + afterDecimal.slice(0, 2);
      } else {
        numericValue = numericValue.slice(0, 4);
      }
      setPrice(numericValue);
    } catch (error) {
      console.log("onPriceChange -> Error When Changing Price ::", error);
    }
  };

  const onTitleChange = (event) => {
    let inputValue = event.target.value;
    const cleanedValue = (inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, ""));
    setTitle(cleanedValue.charAt(0).toUpperCase() + cleanedValue.slice(1));
  };

  const onDescriptionChange = (event) => {
    let inputValue = event.target.value;
    const cleanedValue = (inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, ""));
    setDescription(cleanedValue);
  };

  const handleCheckboxChange = () => {
    setPrice("");
    setForTrade(!forTrade);
  };

  const getAddress = (params) => {
    const userAddress = {
      city: params?.city,
      country: params?.country,
      province: params?.province,
      postalCode: params?.postalCode,
      address: params?.address
    };
    let { city, country, province, postalCode, address, address1 } = userAddress ? userAddress : {};
    city =
      city !== "" && city
        ? city.replace(/\w*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase())
        : "";
    country =
      country !== "" && country
        ? country.replace(
          /\w*/g,
          (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
        )
        : "";

    const uAddress = getFormattedAddress(
      address ?? "",
      address1 ?? "",
      city ?? "",
      province ?? "",
      country ?? "",
      postalCode ?? "",
      3
    );
    return uAddress;
  };

  const handleShowChooseSite = () => {
    setShowSites(true);
  };
  const onSelectSite = (item) => {
    setSelectedSiteDetails(item);
  };

  const isPublishBtnDisable = () => {
    return title.trim() === "" || selectedSiteDetails === null || (price === "" && !forTrade);
  };

  const onImagePreview = (index) => {
    setPictureViewerOpen(true);
    setPictureViewIndex(index);
  };

  const onPublish = async () => {
    try {
      setBtnLoading(true);
      if (deletedImages?.length !== 0) {
        deletedImages.map(async (item) => {
          const obj = {
            UserId: Number(currentUserId),
            ReturnRecordId: false,
            ReturnRecordError: true,
            SoftDelete: true,
            DeleteList: [
              {
                Id: item.id,
                ModifiedBy: Number(currentUserId)
              }
            ]
          };
          await Postrequestcall(DELETE_BUY_SELL_USER_ITEM_PICTURES, obj, loginData?.accessToken);
        });
      }

      const listingObject = {
        Id: props?.editListItemDetails?.id ?? 0,
        UserId: Number(currentUserId),
        Title: title,
        Price: forTrade ? 0 : price,
        ForTrade: forTrade,
        Description: description,
        SiteId: selectedSiteDetails?.siteId,
        ModifiedBy: Number(currentUserId)
      };
      const res = await Postrequestcall(
        BUY_SELL_SAVE_USER_ITEM,
        listingObject,
        loginData?.accessToken
      );

      const newPictures = pictures.filter((pic) => !pic.id);
      const promises = newPictures.map(async (pic) => {
        const formData = new FormData();
        formData.append("Id", 0);
        formData.append("BuySellUserItemId", res?.data?.data ?? 0);
        formData.append("Name", pic);
        formData.append("Main", true);
        formData.append("ModifiedBy", Number(currentUserId));
        return Postrequestcall(
          BUY_SELL_SAVE_USER_ITEM_PICTURE,
          formData,
          loginData?.accessToken,
          "formData"
        );
      });

      // Wait for all images to save
      await Promise.all(promises);
      props?.getUpdatedData();
      setBtnLoading(false);
      onClose();
    } catch (err) {
      setBtnLoading(false);
      console.log("onPublish -> Error When Saving Items Picture :: ", err);
    }
  };

  return (
    <Box>
      <Modal open={props?.open} onClose={onClose} closeAfterTransition>
        <Box
          className="user-modal-responsive"
          sx={{
            borderRadius: "24px !important",
            p: "0 !important", // Override global 15px padding
            overflow: "hidden !important", // Let internal boxes handle scroll
            bgcolor: "white",
            maxWidth: "600px !important",
            maxHeight: "90vh !important", // Override global 600px limit
            height: "auto",
            display: "flex",
            flexDirection: "column",
            outline: "none"
          }}
        >
          {/* Header */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              p: 2.5,
              borderBottom: "1px solid #f1f5f9",
              flexShrink: 0,
              bgcolor: "white"
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: 700 }}>
            {props?.editListItemDetails ? TEXT_EDIT_LISTING_HEADER : TEXT_CREATE_NEW_LISTING_HEADER}
            </Typography>
            <IconButton onClick={onClose} size="small">
              <Close />
            </IconButton>
          </Box>

          <Box sx={{ p: 3, overflowY: "auto", flexGrow: 1, minHeight: 0 }}>
            <Stack spacing={3}>
              {/* Image Upload Section */}
              <Box>
                <Typography variant="subtitle2" sx={{ mb: 1, color: "text.secondary",  fontWeight: 600 }}  >
                  {TEXT_PHOTOS_LABEL}
                </Typography>
                <Box
                  sx={{
                    border: "2px dashed #e2e8f0",
                    borderRadius: "16px",
                    p: 2,
                    bgcolor: "#f8fafc"
                  }}
                >
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Stack direction="row" spacing={2} sx={{ overflowX: "auto", pb: 1, scrollbarWidth: "none" }}>
                        <Button
                          component="label"
                          sx={{
                            minWidth: 100,
                            height: 100,
                            borderRadius: "12px",
                            bgcolor: "white",
                            border: "1px solid #e2e8f0",
                            color: "#3b82f6",
                            flexDirection: "column",
                            gap: 1,
                            textTransform: "none",
                            "&:hover": { bgcolor: "#eff6ff", borderColor: "#3b82f6" }
                          }}
                        >
                          <ImageIcon />
                          <Typography variant="caption" sx={{ fontWeight: 600 }}>{TEXT_ADD_PHOTO}</Typography>
                          <input type="file" multiple accept="image/*" onChange={handleChooseFile} hidden />
                        </Button>

                        {pictures.map((picItem, picIndex) => (
                          <Box
                            key={picIndex}
                            sx={{
                              position: "relative",
                              minWidth: 100,
                              height: 100,
                              borderRadius: "12px",
                              overflow: "hidden",
                              border: "1px solid #e2e8f0"
                            }}
                          >
                            <img
                              src={picItem?.id ? picItem?.name : URL.createObjectURL(picItem)}
                              style={{ width: "100%", height: "100%", objectFit: "cover" }}
                              alt={`Upload ${picIndex}`}
                              onClick={() => onImagePreview(picIndex)}
                            />
                            <IconButton
                              size="small"
                              onClick={() => onDeletePicturePressed(picItem, picIndex)}
                              sx={{
                                position: "absolute",
                                top: 4,
                                right: 4,
                                bgcolor: "rgba(0,0,0,0.5)",
                                color: "white",
                                "&:hover": { bgcolor: "rgba(0,0,0,0.7)" }
                              }}
                            >
                              <CloseIcon sx={{ fontSize: 14 }} />
                            </IconButton>
                          </Box>
                        ))}
                      </Stack>
                    </Grid>
                  </Grid>
                </Box>
              </Box>

              {/* Title and Price */}
              <TextField
                label={TEXT_SELLING_TRADING_LABEL}
                fullWidth
                variant="outlined"
                value={title}
                onChange={onTitleChange}
                placeholder={TEXT_SELLING_TRADING_PLACEHOLDER}
                sx={{ "& .MuiOutlinedInput-root": { borderRadius: "12px" } }}
              />

              <Stack direction="row" spacing={2} sx={{ alignItems: "flex-start" }}>
                <Box sx={{ flexGrow: 1 }}>
                  <TextField
                    disabled={forTrade}
                    label={TEXT_PRICE_LABEL}
                    fullWidth
                    value={price}
                    onChange={(e) => onPriceChange(e.target.value.replace(/^[^A-Za-z0-9]+/, ""))}
                    placeholder={TEXT_PRICE_PLACEHOLDER}
                    slotProps={{
                      input: {
                        startAdornment: !forTrade && <InputAdornment position="start">$</InputAdornment>,
                        sx: { borderRadius: "12px" }
                      }
                    }}
                  />
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    height: "56px",
                    px: 2,
                    border: "1px solid #e2e8f0",
                    borderRadius: "12px",
                    bgcolor: forTrade ? "#eff6ff" : "white",
                    borderColor: forTrade ? "#3b82f6" : "#e2e8f0"
                  }}
                >
                  <Checkbox checked={forTrade} onChange={handleCheckboxChange} sx={{ p: 0.5 }} />
                  <Typography variant="body2" sx={{ ml: 0.5,  fontWeight: 600 }} >{TEXT_FOR_TRADE_CHECKBOX}</Typography>
                </Box>
              </Stack>

              <TextField
                multiline
                rows={4}
                label={TEXT_DESCRIPTION_LABEL}
                fullWidth
                value={description}
                onChange={onDescriptionChange}
                placeholder={TEXT_DESCRIPTION_PLACEHOLDER}
                sx={{ "& .MuiOutlinedInput-root": { borderRadius: "12px" } }}
              />

              {/* Site Selection */}
              <Box>
                <Typography variant="subtitle2" sx={{ mb: 1, color: "text.secondary",  fontWeight: 600 }}  >
                  {TEXT_LOCATION_SITE_LABEL}
                </Typography>
                {selectedSiteDetails == null ? (
                  <Button
                    fullWidth
                    variant="outlined"
                    onClick={handleShowChooseSite}
                    sx={{
                      borderRadius: "12px",
                      py: 2,
                      borderStyle: "dashed",
                      color: "text.secondary",
                      borderColor: "#e2e8f0",
                      "&:hover": { borderColor: "#3b82f6", bgcolor: "#f8fafc" }
                    }}
                  >
                    {TEXT_SELECT_SITE_BTN}
                  </Button>
                ) : (
                  <Card
                    sx={{
                      borderRadius: "16px",
                      border: "1px solid #3b82f6",
                      bgcolor: "#f0f7ff",
                      boxShadow: "none"
                    }}
                  >
                    <ListItem
                      sx={{ p: 1.5 }}
                      secondaryAction={
                        <IconButton onClick={() => setSelectedSiteDetails(null)} size="small">
                          <Close />
                        </IconButton>
                      }
                    >
                      <Avatar
                        variant="rounded"
                        src={selectedSiteDetails?.mainPictureUrl || defaultProjectImage}
                        sx={{ width: 50, height: 50, borderRadius: "8px" }}
                      />
                      <Box sx={{ ml: 2, mr: 3 }}>
                        <Typography variant="subtitle2" sx={{color: "#1e293b",  fontWeight: 700 }} >
                          {selectedSiteDetails?.siteName}
                        </Typography>
                        <Typography variant="caption" sx={{ color: "text.secondary" }} noWrap sx={{ display: "block", maxWidth: { xs: 200, sm: 350 } }}>
                          {getAddress(selectedSiteDetails)}
                        </Typography>
                      </Box>
                    </ListItem>
                  </Card>
                )}
              </Box>
            </Stack>
          </Box>

          <Box sx={{ p: 3, borderTop: "1px solid #f1f5f9", flexShrink: 0, bgcolor: "white" }}>
            <Button
              variant="contained"
              onClick={onPublish}
              fullWidth
              loading={btnLoading}
              disabled={isPublishBtnDisable()}
              sx={{
                borderRadius: "12px",
                py: 1.5,
                fontSize: "1rem",
                fontWeight: 700,
                textTransform: "none",
                bgcolor: "#3b82f6",
                "&:hover": { bgcolor: "#2563eb" }
              }}
            >
              {props?.editListItemDetails ? TEXT_UPDATE_LISTING_BTN : TEXT_CREATE_LISTING_BTN}
            </Button>
          </Box>
        </Box>
      </Modal>

      {pictureViewerOpen && (
        <PictureViewer
          isOpen={pictureViewerOpen}
          onClose={() => setPictureViewerOpen(false)}
          pictures={pictures.map((pic) => ({
            src: pic?.id ? pic?.name : URL.createObjectURL(pic),
            alt: ""
          }))}
          viewerIndex={pictureViewIndex}
        />
      )}
      {showSites && (
        <SiteListForBuySell
          isOpen={showSites}
          onClose={() => setShowSites(false)}
          onSelectSite={(e) => onSelectSite(e)}
        />
      )}
    </Box>
  );
};

export default AddListing;
